import axios from '@/utils/axios';

// 获取省列表
export function ClientNotice() {
    return axios({
        url: '/clientNotice',
        method: 'get',
        params: { },
    });
}
